import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';

const SupplierViewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../entityView/supplier-view/supplierViewPage'
    )
);

export const supplierViewRoutes: PageRouter[] = [
  {
    name: 'overview',
    path: '/overview/:tabType?/:tableEntityType?/:recordId?',
    component: SupplierViewPage,
    exact: true,
    tabs: []
  },
  {
    name: 'local-vendors',
    path: '/local-vendors',
    component: SupplierViewPage,
    exact: true,
    tabs: []
  },
  {
    name: 'similar-suppliers',
    path: '/similar-suppliers',
    component: SupplierViewPage,
    exact: true,
    tabs: []
  }
];
